import AuthLeftPanel from "../components/AuthLeftPanel";
import { useSignupViewModel } from "../../viewmodels/useSignupViewModel";
import { SIGNUP_TEXT } from "../../domain/constants/constants";
import HowItWorksPopup from "../components/HowItWorksPopup";
import { styles as s } from "../../styles/signupstyles";
import OtpVerificationScreen from "./OtpVerificationScreen";

import SignupHeader from "../components/SignupHeader";
import SocialLoginSection from "../components/SocialLoginSection";
import Divider from "../components/Divider";
import MethodToggle from "../components/MethodToggle";
import ContactInput from "../components/ContactInput";
import ContinueButton from "../components/ContinueButton";
import TermsSection from "../components/TermsSection";

export default function SignupScreen() {
    const vm = useSignupViewModel();

    return (
        <>
            <div className={s.container}>
                <div className={s.wrapper}>
                    <AuthLeftPanel />

                    {vm.step === "signup" ? (
                        <div className={s.rightPanel}>
                            <div className={s.form}>
                                <SignupHeader
                                    onHowItWorks={vm.openHowItWorks}
                                />

                                <SocialLoginSection
                                    onGoogle={() => { }}
                                    onApple={() => { }}
                                />

                                <Divider
                                    text={SIGNUP_TEXT.or}
                                />

                                <MethodToggle
                                    value={vm.method}
                                    onChange={vm.setMethod}
                                />

                                <ContactInput
                                    method={vm.method}
                                    email={vm.email}
                                    phone={vm.phone}
                                    setEmail={vm.setEmail}
                                    setPhone={vm.setPhone}
                                />

                                <ContinueButton
                                    disabled={
                                        vm.method === "email"
                                            ? !vm.isValidEmail
                                            : !vm.isValidPhone
                                    }
                                    onClick={vm.goToOtp}
                                />

                                <TermsSection
                                    method={vm.method}
                                />
                            </div>
                        </div>
                    ) : (
                        <OtpVerificationScreen
                            method={vm.method}
                            destination={
                                vm.method === "email"
                                    ? vm.email
                                    : vm.phone
                            }
                            onBack={() => vm.setStep("signup")}
                        />
                    )}
                </div>
            </div>

            {vm.showHowItWorks && (
                <HowItWorksPopup
                    onClose={vm.closeHowItWorks}
                />
            )}
        </>
    );
}